const faqData = [
  {
    index: "전체",
    items: [],
  },
  {
    index: "로그인",
    items: [
      {
        Q: `로그인 시 "등록되지 않은 휴대전화 번호입니다."라는 메시지가 나타납니다.`,
        A: `아래 상황에 해당하는 경우 안내되는 메세지이므로, 아래의 내용에 따라 적절한 조치를 취해야 합니다.<br /><br />
        &nbsp;&nbsp;- 등록하신 휴대전화 번호와 다르게 입력한 경우 접속이 불가합니다. 등록 시 사용한 휴대전화 번호를 입력하여 접속하시기 바랍니다.<br />
        &nbsp;&nbsp;- 안내된 사전점검일 외 다른 시점에 로그인한 경우 접속이 불가합니다. 반드시 안내된 사전점검일에 접속을 시도하시기 바랍니다.`,
      },
      {
        Q: `로그인 시 "인증 번호가 일치하지 않습니다. 확인 후 다시 로그인을 시도해주십시오."라는 메시지가 나타납니다.`,
        A: `휴대전화로 전달받은 인증번호와 다르게 입력한 경우 안내되는 메시지입니다.<br />
        전달받은 인증번호 확인 후 정확히 입력해주시기 바랍니다.<br/>단, 3분 내 정확한 인증번호를 입력하지 못한 경우 <b>[인증번호 발송]</b>버튼을 새로 클릭하여 새로운 인증번호로 로그인해야 합니다.`,
      },
      {
        Q: `로그인 시 "지금은 로그인하실 수 없습니다. 로그인 가능 시간을 확인해 주십시오."라는 메시지가 나타납니다.`,
        A: `VAC 프로그램은 안내된 로그인 가능 시간 외에는 로그인이 불가합니다.<br />
        로그인 가능 시간이 지난 후 접속하는 경우 본 평가를 진행할 수 없습니다. 안내된 일정과 로그인 가능 시간을 확인하시기 바랍니다.
        `,
      },
      {
        Q: `로그인 시 "사전점검이 완료되었습니다. 사전점검은 1회만 하실 수 있습니다"라는 메시지가 나타납니다.`,
        A: `사전점검은 1회만 가능합니다. 사전점검 실시 후 <b>[종료]</b>버튼을 클릭하여 사전점검을 완료한 경우에는 재로그인할 수 없습니다.<br />
        본 평가 로그인 가능 기간이 되면 본 평가를 위해 로그인하실 수 있습니다.`,
      },
      {
        Q: `로그인 시 "사전점검을 실시하지 않으면 평가를 응시하실 수 없습니다."라는 메시지가 나타납니다.`,
        A: `사전에 안내된 사전점검 기간 내 사전점검을 완료하지 않은 경우 안내되는 메시지입니다.<br />사전점검을 완료하지 않은 대상자는 본 평가를 진행하실 수 없습니다.`,
      },
      {
        Q: `로그인 시 "평가 중 부정행위가 감지되었습니다. 따라서 다시 로그인 하실 수 없습니다."라는 메시지가 나타납니다.`,
        A: `평가 중 추가 모니터 연결 시도, <b>Ctrl</b>/<b>Alt</b>/<b>Shift</b> 반복적 사용 등 부정행위로 인해 VAC 프로그램이 강제 종료된 이후, 재로그인하는 경우 나타나는 메시지이며 종료된 후에는 다시 로그인하실 수 없습니다.`,
      },
      {
        Q: `로그인 시 "응시자님께서는 이미 평가를 완료하셨습니다. 평가 완료 후에는 다시 로그인하실 수 없습니다."라는 메시지가 나타납니다.`,
        A: `본 평가를 종료한 이후 재로그인하는 경우 나타나는 메시지입니다.<br />평가 종료 이후에는 다시 로그인하실 수 없습니다.`,
      },
    ],
  },
  {
    index: "주변기기",
    items: [
      {
        Q: `(화면공유, 웹캠) PC 화면이 공유되지 않거나 웹캠이 나오지 않습니다. 어떻게 해야 하나요?`,
        A: `
          프로그램 종료 후 아래 제시하는 순서대로 설정한 후 재로그인하시기 바랍니다.<br /><br />
          <div class="faq_os">- Windows</div>
          <br />
          <div class="faq_sub_title">1. [ 카메라 앱 "켬" 확인 ]</div>
          ① 윈도우 검색 창 "카메라" 검색 ⇒ ② 카메라 앱 클릭 ⇒  ③ 화면 카메라 잘 작동되는지 확인 후,  좌측 상단 톱니바퀴 클릭 ⇒  ④ 관련 설정에 "개인 정보 설정 변경하기" 클릭 ⇒ ⑤ 다른 앱으로 이동하시겠습니까? "예" 클릭 ⇒ ⑥ 왼쪽 "카메라" 목록 클릭 ⇒ ⑦ 앱에서 카메라 엑세스 허용 "켬" ⇒ ⑧ 카메라에 엑세스할 수 있는 Microsoft Store 앱 선택 하단 카메라 "켬" 확인<br />
          <br />
          <div class="faq_sub_title">2. [ 마이크 앱 "켬" 확인 ]</div>
          ① 왼쪽 "마이크" 목록 클릭 ⇒ ② 앱에서 마이크에 엑세스하도록 허용 "켬" 확인 ⇒ ③ 마이크에 엑세스할 수 있는 Microsoft Store 앱 선택 ⇒ ④ 하단 카메라 "켬" 확인<br />
          <br />
          <div class="faq_sub_title">3. [ 구글 최신버전 확인 ]</div>
          구글 크롬 최신 버전 확인<br />
          <br />
          <div class="faq_sub_title">4. 컴퓨터 재부팅 후, 프로그램 재로그인</div>
          <br />
          <br />
          <div class="faq_os">- Mac</div>
          아래 순서대로 카메라를 설정하시기 바랍니다.<br />
          <br />
          <div class="faq_sub_title">① 시스템 환경 설정 ⇒ ② 보안 및 개인 정보 보호 클릭 ⇒ ③ 카메라 항목 선택 ⇒ ④ Chrome 항목과 VAC_setup 항목 체크</div>
          `,
      },
      {
        Q: `(웹캠) 휴대전화 화상통화를 활용하여 웹캠을 진행해도 되나요?`,
        A: `웹캠은 노트북에 내장되어 있는 카메라 또는 별도로 설치된 웹캠만 사용 가능하며, 평가 중에는 휴대전화 사용이 불가합니다.`,
      },
      {
        Q: `(마이크) 마이크가 나오지 않습니다. 어떻게 해야 하나요?`,
        A: `
          프로그램 종료 후 아래 제시하는 순서대로 설정한 후 재로그인하시기 바랍니다.<br /><br />
          <div class="faq_os">- Windows</div>
          <br />
          <div class="faq_sub_title">① 제어판 ⇒ ② 소리 ⇒  ③ 녹음 탭 클릭 ⇒  ④ 마이크에 오른쪽 마우스 ⇒ ⑤ 사용 ⇒ ⑥ 속성 ⇒ ⑦ 수준 탭 <br />
          ⇒ ⑧ 음소거 해제</div>
          <br />
          <br />
          <div class="faq_os">- Mac</div>
          <br />
          <div class="faq_sub_title">① 시스템 환경 설정 ⇒ ② 보안 및 개인 정보 보호 클릭 ⇒ ③ 마이크 항목 선택 ⇒ ④ Chrome 항목과 VAC_setup 항목 체크</div>
          `,
      },
      {
        Q: `(스피커) 소리가 들리지 않습니다. 어떻게 해야 하나요?`,
        A: `
          프로그램 종료 후 아래 제시하는 순서대로 설정한 후 재로그인하시기 바랍니다.<br /><br />
          <div class="faq_sub_title">① 제어판 ⇒ ② 소리 ⇒  ③ 재생 ⇒  ④ 스피커에 오른쪽 마우스 ⇒ ⑤ 사용 ⇒ ⑥ 속성 ⇒ ⑦ 수준 탭 <br />
          ⇒ ⑧ 음소거 해제</div>
          `,
      },
      {
        Q: `(스피커) 헤드셋이나 이어폰을 사용해도 되나요?`,
        A: `귀에 꽂는 디바이스는 사용이 불가합니다.<br />노트북은 내장된 스피커를 활용하시고 데스크탑은 별도의 스피커를 준비하시기 바랍니다.<br />스피커는 감독위원과의 소통 용도로만 사용됩니다.`,
      },
      {
        Q: `(모니터) 추가 모니터(듀얼 모니터)를 연결하여 진행해도 되나요?`,
        A: `부정행위 방지를 위해 추가 모니터 연결은 불가하며, 추가 모니터가 연결된 상태에서 로그인을 시도할 경우 프로그램이 강제 종료됩니다.<br /><br />
        ※ 로그인 과정에서 추가 모니터로 인한 강제 종료는 부정행위로 간주되지 않으나, 로그인 이후 추가 모니터를 연결할 시 부정행위로 간주되며 프로그램이 강제 종료됩니다.<br />
        ※ 노트북에 스크린패드를 장착한 경우 추가 모니터로 인식되므로 반드시 스크린패드를 분리해주시기 바랍니다.
        `,
      },
    ],
  },
  {
    index: "기타",
    items: [
      {
        Q: `(필기) 종이에 메모하거나 별도의 계산기를 사용해도 되나요?`,
        A: `평가 중에는 종이와 필기구, 별도의 계산기는 사용할 수 없으며, 사용 시 부정행위로 간주됩니다.<br />
        VAC 프로그램에서 제공하는 메모장과 계산기 기능을 사용하시기 바랍니다.`,
      },
      {
        Q: `(사전점검) 사전점검과 본 평가 때 PC나 응시장소 등 환경이 달라도 상관없나요?`,
        A: `사전점검은 PC/네트워크 상태, 소음 및 타인출입방지 등 본 평가 시 문제가 발생할 수 있는 환경적 문제 전반을 점검하기 위한 절차이므로, 반드시 본 평가와 동일한 환경에서 사전점검을 실시해야 합니다.`,
      },
      {
        Q: `(사전점검) 사전점검을 다시 하고 싶은데 어떻게 해야 하나요?`,
        A: `사전점검은 1회만 가능하며, 완료 후에는 사전점검을 다시 실시하실 수 없습니다.`,
      },
      {
        Q: `(사전점검) 사전점검을 하지 않아도 본 평가에 접속할 수 있나요?`,
        A: `사전점검이 완료되지 않은 경우 본 평가일에 프로그램 접속이 불가합니다. 반드시 정해진 기간 내에 사전점검을 실시하여 안내 영상 시청 및 VAC 프로그램 정상 작동 여부를 확인하시기 바랍니다.<br /><br />
        ※ 사전점검 실시 후 <b>[종료]</b> 버튼을 클릭하여 정상적으로 종료되어야만 사전점검이 완료된 것으로 변경됩니다.<br />(강제 종료 또는 오른쪽 상단의 <b>[ X ]</b> 버튼으로 종료하지 않도록 주의해 주시기 바랍니다.)`,
      },
      {
        Q: `(문의) 문의사항이 있는 경우 어떻게 해야 하나요? `,
        A: `문의사항이 있는 경우 로그인 화면 또는 사전점검 대기 화면 우측 상단의 <b>[문제가 있나요?]</b> 버튼을 클릭하여 FAQ를 확인하거나 1:1 문의를 작성해주시기 바랍니다.<br /><br />
        1:1 문의에 대한 답변은 문의 작성 시 입력하신 휴대전화 번호로 문자를 전송할 예정입니다.<br /><br />
        이외에도 문의사항이 있는 경우, <b>비상연락처(070-4915-5593, 평일 09시 ~ 17시)</b>로 문의하시기 바랍니다.
        `,
      },
    ],
  },
];

export default faqData;
